import marcaBlancaServices from 'legacyfrontend/api/services/marcaBlancaServices';
import { SET_BANNERS, SET_BANNERS_ERROR } from './action-types';

export const getBanners =
  ({ id = null, esDefault = true, defaultOnly, showHomeOnly }) =>
    async (dispatch, getState) => {
      const state = getState();
      const seccionId = id;
      const empresaId = state.applicationState.applicationId;

      try {
        const response = await marcaBlancaServices.getBanners({
          empresaId,
          seccionId,
          esDefault,
          defaultOnly,
          showHome: showHomeOnly,
        });

        let bannersData = [];
        if (response?.data) {
          if (response.data.object && Array.isArray(response.data.object)) {
            bannersData = response.data.object;
          } else if (Array.isArray(response.data)) {
            bannersData = response.data;
          }
        } else if (Array.isArray(response)) {
          bannersData = response;
        }

        return dispatch({
          type: SET_BANNERS,
          payload: bannersData,
        });
      } catch (error) {
        console.error('Banners error', error);
        return dispatch({ type: SET_BANNERS_ERROR });
      }
    };
